/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { InstallPhotoStatus } from '../models/InstallPhotoStatus';
import type { PaginatedInstallPhotoStatusList } from '../models/PaginatedInstallPhotoStatusList';
import type { PatchedInstallPhotoStatus } from '../models/PatchedInstallPhotoStatus';

import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';

export class ClientsInstallPhotoStatusService {

    constructor(public readonly httpRequest: BaseHttpRequest) {}

    /**
     * @returns PaginatedInstallPhotoStatusList
     * @throws ApiError
     */
    public clientsInstallPhotoStatusList({
        page,
        pageSize,
    }: {
        /**
         * A page number within the paginated result set.
         */
        page?: number,
        /**
         * Number of results to return per page.
         */
        pageSize?: number,
    }): CancelablePromise<PaginatedInstallPhotoStatusList> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/clients-install-photo-status/',
            query: {
                'page': page,
                'page_size': pageSize,
            },
        });
    }

    /**
     * @returns InstallPhotoStatus
     * @throws ApiError
     */
    public clientsInstallPhotoStatusCreate({
        requestBody,
    }: {
        requestBody: InstallPhotoStatus,
    }): CancelablePromise<InstallPhotoStatus> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/clients-install-photo-status/',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns InstallPhotoStatus
     * @throws ApiError
     */
    public clientsInstallPhotoStatusRetrieve({
        id,
    }: {
        /**
         * A unique integer value identifying this install photo status.
         */
        id: number,
    }): CancelablePromise<InstallPhotoStatus> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/clients-install-photo-status/{id}/',
            path: {
                'id': id,
            },
        });
    }

    /**
     * @returns InstallPhotoStatus
     * @throws ApiError
     */
    public clientsInstallPhotoStatusUpdate({
        id,
        requestBody,
    }: {
        /**
         * A unique integer value identifying this install photo status.
         */
        id: number,
        requestBody: InstallPhotoStatus,
    }): CancelablePromise<InstallPhotoStatus> {
        return this.httpRequest.request({
            method: 'PUT',
            url: '/clients-install-photo-status/{id}/',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns InstallPhotoStatus
     * @throws ApiError
     */
    public clientsInstallPhotoStatusPartialUpdate({
        id,
        requestBody,
    }: {
        /**
         * A unique integer value identifying this install photo status.
         */
        id: number,
        requestBody?: PatchedInstallPhotoStatus,
    }): CancelablePromise<InstallPhotoStatus> {
        return this.httpRequest.request({
            method: 'PATCH',
            url: '/clients-install-photo-status/{id}/',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns void
     * @throws ApiError
     */
    public clientsInstallPhotoStatusDestroy({
        id,
    }: {
        /**
         * A unique integer value identifying this install photo status.
         */
        id: number,
    }): CancelablePromise<void> {
        return this.httpRequest.request({
            method: 'DELETE',
            url: '/clients-install-photo-status/{id}/',
            path: {
                'id': id,
            },
        });
    }

}
